export default "__VITE_ASSET__DdRrQXUw__"